module.exports = __webpack_public_path__ + "img/me.c4dd9065.jpg";